import React from "react";
import {
  StyledDivider,
  StyledSupportCopyCompact,
  StyledSupportCopyText,
} from "./StyledSupportCopyCompact";
import SupportCopyLogo from "./SupportCopyLogo";

function SupportCopyCompact({ assetUrl, displayText }) {
  return (
    <StyledSupportCopyCompact className="mls-c-match-promo__support-compact">
      {displayText && (
        <StyledSupportCopyText className="mls-c-match-promo__support-compact__display-text">
          {displayText}
        </StyledSupportCopyText>
      )}
      {displayText && assetUrl && <StyledDivider />}
      {assetUrl && <SupportCopyLogo />}
    </StyledSupportCopyCompact>
  );
}

export default SupportCopyCompact;
